import { Action } from '@ngrx/store';
import * as models from '../../domain/models';

export const LOAD = '[RM User Detail] Load';
export const LOAD_SUCCESS = '[RM User Detail] Load Success';
export const LOAD_FAIL = '[RM User Detail] Load Fail';
export const RESET = '[RM User Detail] Reset';
export const SET = '[RM User Detail] Set';
export const CANCEL = 'RM User Detail] Cancel';
export const SAVE = '[RM User Detail] Save';
export const SAVE_SUCCESS = '[RM User Detail] Save Success';
export const SAVE_FAIL = '[RM User Detail] Save Fail';
export const TOGGLE_EDIT_MODE = '[RM User Detail] Toggle Edit Mode';
export const BYPASS_LOAD = '[RM User Detail] Bypass Load';

export class ResetAction implements Action {
  readonly type = RESET;
}

export class SetPayload {
  constructor(public item: models.VendorOrganizationUser) {}
}

export class SetAction implements Action {
  readonly type = SET;

  constructor(public payload: SetPayload) {}
}

export class CancelAction implements Action {
  readonly type = CANCEL;
}

export class LoadPayload {
  constructor(public id: number) {}
}

export class LoadAction implements Action {
  readonly type = LOAD;

  constructor(public payload: LoadPayload) {}
}

export class LoadSuccessPayload {
  constructor(public item: models.VendorOrganizationUser) {}
}

export class LoadSuccessAction implements Action {
  readonly type = LOAD_SUCCESS;

  constructor(public payload: LoadSuccessPayload) {}
}

export class LoadFailAction implements Action {
  readonly type = LOAD_FAIL;
}

export class SaveAction implements Action {
  readonly type = SAVE;
}

export class SaveSuccessPayload {
  constructor(public item: models.VendorOrganizationUser) {}
}

export class SaveSuccessAction implements Action {
  readonly type = SAVE_SUCCESS;

  constructor(public payload: SaveSuccessPayload) {}
}

export class SaveFailAction implements Action {
  readonly type = SAVE_FAIL;
}

export class ValidatePayload {
  skip: boolean;
}

export class ToggleEditModeAction implements Action {
  readonly type = TOGGLE_EDIT_MODE;
}

export class BypassAction implements Action {
  readonly type = BYPASS_LOAD;
}

export type Actions =
  | ResetAction
  | LoadAction
  | LoadSuccessAction
  | LoadFailAction
  | SetAction
  | CancelAction
  | SaveAction
  | SaveSuccessAction
  | SaveFailAction
  | ToggleEditModeAction
  | BypassAction;
